import React from 'react'
import LoadingSpin from "react-loading-spin";
const Loading = () => {
    return (
        <div className="react-loading"><LoadingSpin /></div>
    )
}

export default Loading